module.exports = __webpack_public_path__ + "img/ABSA_Group_Limited_Logo.f6be4b0b.svg";